module.exports = __webpack_public_path__ + "img/dll.f685a03a.svg";